import { render, staticRenderFns } from "./SuggestedSpots.vue?vue&type=template&id=780ba79f&scoped=true&"
import script from "./SuggestedSpots.vue?vue&type=script&lang=js&"
export * from "./SuggestedSpots.vue?vue&type=script&lang=js&"
import style0 from "./SuggestedSpots.vue?vue&type=style&index=0&id=780ba79f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780ba79f",
  null
  
)

export default component.exports